// Indian (+91) WhatsApp numbers, matching formatIndianPhone in the backend's utils/phone.js.

/** "98765 43210", "+91 98765-43210" → "+919876543210"; "" when there are no digits. */
export const formatPhoneInput = (value: string): string => {
  if (!value) {
    return "";
  }
  const digits = value.replace(/\D/g, "");
  const withoutCountry = digits.startsWith("91") ? digits.slice(2) : digits;
  const tenDigits = withoutCountry.slice(-10);
  return tenDigits ? `+91${tenDigits}` : "";
};

export const isValidIndianPhone = (value: string): boolean => /^\+91\d{10}$/.test(value);

/** "+919876543210" → "+91 98765 43210" for reading; anything else is shown as stored. */
export const displayPhone = (value: string | null | undefined): string => {
  if (!value) {
    return "";
  }
  const match = /^\+91(\d{5})(\d{5})$/.exec(value);
  return match ? `+91 ${match[1]} ${match[2]}` : value;
};

export const PHONE_INVALID_MESSAGE = "Enter a 10-digit Indian mobile number";
